import styled from 'styled-components';
import ds from 'designsystem';

const CustomField = styled.div`
    display: flex;
    flex-flow: column-reverse;
    position: relative;
    width: 100%;
    margin: ${ds.get('metrics.s')} 0 1em 0;
`;

export default CustomField;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomField.jsx